module.exports = __webpack_public_path__ + "media/images/vehicles/fiesta-881476968424a9038e7f9d1b71726e66.jpg";